import React, { useEffect, useState } from "react";

import { Container } from "./styles";

interface IProps {
  onClick?: () => void;
  criare?: boolean;
  italinea?: boolean;
  animationTrigger?: any;
  error?: number;
}

const Next: React.FC<IProps> = ({
  onClick: onClickCb,
  criare,
  italinea,
  error,
  animationTrigger,
}) => {
  const [animationCounter, setAnimationCounter] = useState(0);

  useEffect(() => {
    setAnimationCounter((prevState) => prevState + 1);
  }, [animationTrigger]);

  return (
    <Container
      criare={criare}
      italinea={italinea}
      onClick={onClickCb}
      key={animationCounter}
      animationCounter={animationCounter > 1}
    >
      Avançar
    </Container>
  );
};

export default Next;
